import { Injectable, Output } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs/Rx';

import { SidebarService, ISidebarContentService } from 'app/services/sidebar.service';
import { TaskService } from 'app/task/task.service';

import { TaskLists } from 'app/shared/models/task-lists.model';
import { Task } from 'app/shared/models/task.model';

export enum SidebarTasksTab {
  MyTasks = 0,
  OtherTasks
}

@Injectable()
export class SidebarTasksService implements ISidebarContentService {
  @Output() onTasksChanged: Subject<any> = new Subject<any>();

  public myTasks: Array<Task>;
  public otherTasks: Array<Task>;
  public selectedTabIndex: Number;

  public isLoading: Boolean;
  public entityId: BehaviorSubject<Number>;

  constructor(
    private sidebarService: SidebarService,
    private taskService: TaskService) {

    this.myTasks = new Array<Task>();
    this.otherTasks = new Array<Task>();
    this.entityId = new BehaviorSubject<Number>(-1);
    this.selectedTabIndex = 0;

    this.entityId.asObservable()
      .subscribe(response => { this.loadTasks(); });
  }

  public setEntityId(entityId:Number) {
    this.setTasks([], []);

    this.entityId.next(entityId);
  }

  public showTab(tab: SidebarTasksTab) {
    this.sidebarService.ensureSidebarIsOpen();
    this.selectedTabIndex = tab;
  }

  public loadTasks() {
    if (this.entityId.value < 0) { return; }

    this.myTasks = [];
    this.otherTasks = [];
    this.isLoading = true;

    this.taskService.fetchTasks(this.entityId.value)
      .subscribe(response => {
        const taskList = response.arrResult as TaskLists;

        this.setTasks(taskList.myTasks, taskList.otherTasks);
      });
  }

  private setTasks(myTasks: Array<Task>, otherTasks: Array<Task>) {
    this.myTasks = myTasks;
    this.otherTasks = otherTasks;
    this.isLoading = false;

    this.onTasksChanged.next(null);
  }

  // ISidebarContentService
  toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }

  ensureSidebarIsOpen() {
    this.sidebarService.ensureSidebarIsOpen();
  }

  ensureSidebarIsClosed() {
    this.sidebarService.ensureSidebarIsClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sidebar-tasks.service.ts